import { Tab, Tabs } from "@mui/material";
import React, { useCallback, useMemo } from "react";

import downloadWorklog from "../../../../styles/svg/download_worklog.svg";
import { useSelector } from "react-redux";
import { getWorklogHistory } from "../../../../sevices/apiWorklog";

function TabsController({ value, onChange }) {
  const groupingUser = useSelector(
    (state) => state.groupingUser.allocationUsers
  );
  const user = useMemo(
    () => groupingUser.map((item) => item?.users).flat(),
    [groupingUser]
  );
  const checkedList = useSelector((state) => state.search.boardSearch);
  const dateRange = useSelector((state) => state.search.dateRange);
  const epicSearch = useSelector((state) => state.search.epicSearch);

  const downloadCsv = useCallback(() => {
    getWorklogHistory(
      user,
      checkedList,
      dateRange,
      epicSearch,
      true,
      value === "by-task"
    )
      .then(async (response) => {
        const text = response.data;

        const blob = new Blob([text], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download = "worklog.csv";
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [user, checkedList, dateRange, epicSearch, value]);

  return (
    <Tabs
      value={value}
      onChange={(event, newValue) => onChange(event, newValue)}
      textColor="primary"
      indicatorColor="primary"
      aria-label="controlled tabs with specific values"
      TabIndicatorProps={{
        className: "tab-indicator",
      }}
      className="tabs-container">
      <Tab
        value="users"
        label="Users"
        className={
          value === "users"
            ? "custom-tab-active"
            : value === "by-board"
            ? "custom-tab"
            : "custom-tab before_milestone"
        }
        style={{ ...(value === "by-board" && { border: "0px" }) }}
      />
      <Tab
        value="by-board"
        label="By Board"
        className={
          value === "by-board"
            ? "custom-tab-active"
            : value === "by-task"
            ? "custom-tab"
            : "custom-tab before_milestone"
        }
        style={{ ...(value === "by-task" && { border: "0px" }) }}
      />
      <Tab
        value="by-task"
        label="By Task"
        className={
          value === "by-task"
            ? "custom-tab-active"
            : "custom-tab before_milestone"
        }
      />
      {value !== "by-board" && (
        <img
          src={downloadWorklog}
          alt="download worklog"
          className="download_worklog"
          onClick={downloadCsv}
        />
      )}
    </Tabs>
  );
}

export default TabsController;
